<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          푸시 상세
        </div>
        <push-detail-component :pushType="'pushDetail'" :pushKey="pushKey"></push-detail-component>
        <div class="pa15 text-center btn_wrap">
          <el-button type="cancel" @click="deletePush">푸시 삭제</el-button>
          <el-button type="cancel" @click="backEvent()" :disabled="disableBtn">목록</el-button>
          <el-button type="cancel" v-if="cancelBtnVisible" @click="deleteBookPush" >예약 취소</el-button>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import PushDetailComponent from "@/components/push/PushDetailComponent";

export default {
  name: "PushDetail",
  mixins: [],
  components: {PushDetailComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      pushKey: this.$route.params.idx,
      disableBtn: false,
      cancelBtnVisible : false
    }
  },
  created() {
  },
  mounted() {
    EventBus.$on('cancelBtnStatus', this.setCancelBtnStatus);
  },
  beforeDestroy() {
    EventBus.$off('cancelBtnStatus')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    deletePush() {
      EventBus.$emit('deletePush');
    },
    backEvent() {
      this.disableBtn = true
      this.$router.back()
    },
    setCancelBtnStatus(visible){
      this.cancelBtnVisible = visible;
    },
    deleteBookPush(){
      EventBus.$emit('deleteBookPush');
    }
  },
  watch: {},
}
</script>

<style lang="scss">
</style>